import React from 'react'

export default function BorderRadiusBottomRight({ color = '#7246B1', style = {} }) {
    return (
        <svg
            className='icons-icon'
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path d='M9 16H13C14.6569 16 16 14.6569 16 13V9' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
